// extracted by mini-css-extract-plugin
export default {"host":"FormattedDate_host__P6-E4"};